export enum AdminPermissions {
    DASHBOARD_READ = 'admin_dashboard_read',
    COURSES_READ = 'admin_courses_read',
    COURSES_WRITE = 'admin_courses_write',
    MODULES_READ = 'admin_modules_read',
    MODULES_WRITE = 'admin_modules_write',
    USERS_READ = 'admin_users_read',
    USERS_WRITE = 'admin_users_write',
    PASSWORDLESS_ACCESS_WRITE = 'admin_passwordless_access_write',
    GROW_WRITE = 'admin_grow_write',
    QUESTION_LIBRARY_WRITE = 'admin_question_library_write',
    TEAMS_WRITE = 'admin_teams_write',
    PERFORMANCE_REVIEW_WRITE = 'admin_performance_review_write',
    CERTIFICATION_WRITE = 'admin_certification_write',
    SETTINGS_WRITE = 'admin_settings_write',
    REPORTS_WRITE = 'admin_reports_write',
    CAREER_MODEL_WRITE = 'admin_career_model_write',
    QUALIFICATIONS_WRITE = 'admin_qualifications_write',
    TENANT_MANAGEMENT = 'tenant_management',
}
